import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }

});

export const figure53 = {
chart: {
zoomType: 'xy',
animation: false,
marginTop: 50,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'bar',
height: '700px',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
 fontFamily: 'Montserrat'
}
},
credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},
plotOptions: {
series: {
borderWidth: 0,
stacking: 'normal',
}
},
exporting: {
enabled: false
},
xAxis: [{
tickWidth: 0,
labels: {
  groupedOptions: [{
			  style: {
					 transform: 'unset'
				 },
		  }],
		  style: {
					 transform: 'translateX(11px)'
				 },
				 align: 'right'
},
categories: [
{
  name: "Océanie (à l’exception de l’Australie et de la Nouvelle-Zélande)",
  categories: ["Polynésie","Micronésie", "Mélanésie"]
},
{
  name: "Asie de l’Ouest et Afrique du Nord",
	categories: ["Afrique du Nord", "Asie de l’Ouest"]
},
{
  name: "Afrique subsaharienne",
	categories: ["Afrique australe", "Afrique de l’Ouest", "Afrique centrale", "Afrique de l’Est"]
},
{
  name: "Asie de l’Est et Asie du Sud-Est",
	categories: ["Asie du Sud-Est","Asie de l’Est"]
},
{
  name: "Asie centrale et Asie du Sud",
	categories: ["Asie centrale","Asie du Sud"]
},
{
  name: "Amérique latine et Caraïbes",
	categories: ["Amérique du Sud", "Amérique centrale", "Caraïbes"]
},
{
  name: "Amérique du Nord et Europe",
	categories: ["Europe du Sud", "Europe de l’Ouest", "Europe du Nord", "Europe de l’Est", "Amérique du Nord"]
},

      ],
      lineColor: "#d7d7d7",
      tickColor: "#d7d7d7",
      tickLength: 25,
}],
yAxis: [{
  labels: {
		  style: {
				 fontWeight: 'normal',
				 color: '#999999',
				 fontSize: '11px'
			 },
	  },
	  min: 80,
	  max: 110,
	  tickInterval: 10,	
	  format: '{value}%',
	  gridLineWidth: 1,
	  floor: 0,

	  title: {
		  text: '',
		  style: {
				color: Highcharts.getOptions().colors[1]
			}
	  }
}],
tooltip: {
  shared: true,
  useHTML: true,
  hideDelay: 500,
  backgroundColor: null,
  borderWidth: 0,
  shadow: false,
  valueSuffix: '%',
  style: {
		  padding: 0
	  }
},
legend: {
  enabled: false,
},

series: [{
  name: '',
  color: '#bf9000',
  data: [
	 100.71,
	 98.16,
	 102.31,
	 103.19,
	 101.36,
	 100.24,
	 85.70,
	 104.29,
	 88.14,
	 97.72,
	 99.72,
	 99.99,
	 97.73,
	 97.91,
	 99.69,
	 99.62,
	 97.81,
	 102.48,
	 100.84,
	 98.77,
	 105.14,
	]
}]
}
